import Component from "../../lib/component";
import { svgForBackgroundImage } from "@rankers/helpers/img";
import iconStar from "./assets/icon__star.svg";

export const StarRatingConfig = {
  componentTypeKey: "StarRating",
  baseHtmlClass: "star_rating",
  selector: ".star_rating",

  datasetConfigKey: "star_rating__config",

  value: 0,
  label: "Rating",
  max: 5,
};

export class StarRating extends Component {
  static get config() {
    return StarRatingConfig;
  }

  constructor(id_or_element) {
    super({ element: id_or_element, config: StarRating.config });

    this.setDatasetConfig(StarRating.config.datasetConfigKey);
    this.value = this.getDatasetConfigValue("value") || StarRating.config.value;
    this.max = this.getDatasetConfigValue("max") || StarRating.config.max;
    this.label = this.getDatasetConfigValue("label") || StarRating.config.label;
    this.prefix = this.getDatasetConfigValue("prefix");
    this.suffix = this.getDatasetConfigValue("suffix");

    // Make JS authoritative on symbol count. CSS reserves the widget's box at
    // first paint via --symbol-count from the inline style; this line ensures
    // the post-init computed value matches the actual stamped symbol count
    // even if the inline value was wrong or missing.
    this.element.style.setProperty("--symbol-count", this.max);

    this.buildDOM();
    this.render();
  }

  buildDOM() {
    this.element.innerHTML = "";

    // Prefix element
    if (this.prefix) {
      this.prefixElement = document.createElement("span");
      this.prefixElement.classList.add("star_rating__prefix");
      this.prefixElement.innerText = this.prefix;
      this.element.appendChild(this.prefixElement);
    }

    // Symbols container
    this.symbolsElement = document.createElement("span");
    this.symbolsElement.classList.add("star_rating__symbols");
    this.symbolsElement.setAttribute("role", "img");
    this.symbolsElement.setAttribute("aria-label", this.label);
    this.element.appendChild(this.symbolsElement);

    // Build star symbols
    this.symbolElements = [];
    const maskValue = svgForBackgroundImage(iconStar);

    for (let i = 0; i < this.max; i++) {
      const symbol = this.createSymbol(i + 1, maskValue);
      this.symbolElements.push(symbol);
      this.symbolsElement.appendChild(symbol);
    }

    // Suffix element
    if (this.suffix) {
      this.suffixElement = document.createElement("span");
      this.suffixElement.classList.add("star_rating__suffix");
      this.suffixElement.innerText = this.suffix;
      this.element.appendChild(this.suffixElement);
    }
  }

  createSymbol(index, maskValue) {
    const symbol = document.createElement("span");
    symbol.classList.add("star_rating__symbol");
    symbol.dataset.index = index;

    // Apply mask via JS
    symbol.style.webkitMaskImage = maskValue;
    symbol.style.maskImage = maskValue;

    return symbol;
  }

  render() {
    this.symbolElements.forEach((symbol, i) => {
      const starIndex = i + 1;
      let fillPercent;

      if (this.value >= starIndex) {
        fillPercent = 100;
      } else if (this.value > starIndex - 1) {
        fillPercent = (this.value - (starIndex - 1)) * 100;
      } else {
        fillPercent = 0;
      }

      symbol.style.setProperty("--fill-percent", `${fillPercent}%`);
    });
  }

  setValue(newValue) {
    this.value = Math.max(0, Math.min(this.max, newValue));
    this.render();
  }
}
